<template>
	<div class="ui-brackets-rounds component">
		<div class="ui-brackets-rounds__list">
			<div
				v-for="(item, index) in rounds"
				class="ui-brackets-rounds__item"
				:class="{ 'is-active': isActiveRound(item) }"
				:key="index"
			>
				<span>Round{{ item.round }}/{{ rounds.length }}</span>
				<span>
					<UiBaseIcon
						iconName="crown"
						width="15"
						height="14"
					/>
					<span>B01</span>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	import Moment from 'moment'
	import UiBaseIcon from '../../components/icons/UiBaseIcon'

	export default {
		name: 'UiBracketsRounds',
		components: {
			UiBaseIcon
		},
		props: {
			rounds: Array
		},
		methods: {
			isActiveRound (round) {
				const moment = new Moment()
				return moment.isAfter(round.startedAt)
			}
		}
	}
</script>

<style lang="scss">
	.ui-brackets-rounds {
		margin-bottom: 20px;

		&__list {
			display: flex;
			align-items: center;
		}

		&__item {
			display: flex;
			align-items: center;
			justify-content: space-between;
			min-width: 278px;
			padding: 11px 25px;
			background-color: #2F2F2F;
			border: 1px solid #2F2F2F;
			border-radius: 5px;

			+ * {
				margin-left: 20px;
			}

			.ui-icon-base {
				color: #00E7DF;
				margin-right: 5px;
			}

			> span {
				&:first-child {
					font-weight: 700;
					font-size: 14px;
					line-height: 28px;
					letter-spacing: 0.15px;
					text-transform: uppercase;
					color: #8F8F8F;
				}

				&:last-child {
					font-size: 14px;
					line-height: 20px;
					letter-spacing: 0.25px;
					color: #8F8F8F;

					> * {
						vertical-align: middle;
					}
				}
			}

			&.is-active {
				background: #2F2F2F;
				border: 1px solid #00E7DF;

				> span {
					&:first-child {
						color: #fff;
					}
				}
			}
		}
	}
</style>
